/**
 * @generated SignedSource<<ccd8709998301d3b6fcb01a8da61b857>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedNewArrivals_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedNewArrivalsModule_viewer" | "SharedFavoritesProvider_viewer">;
  readonly " $fragmentType": "HpSharedNewArrivals_viewer";
};
export type HpSharedNewArrivals_viewer$key = {
  readonly " $data"?: HpSharedNewArrivals_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedNewArrivals_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedNewArrivals_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedFavoritesProvider_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HpSharedNewArrivalsModule_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "94b96a12977ba176493789991eae01a5";

export default node;
